import { TSalesData, TSalesDataUploadResp } from 'pages/SalesData/types';
import { cdmApi } from '.';

const PREFIX = '/sales-data';

const SalesDataApi = cdmApi.injectEndpoints({
    endpoints: (builder) => ({
        getSalesData: builder.query<TSalesData[], void>({
            query: (params) => ({ url: `${PREFIX}/`, method: 'get', params }),
            providesTags: () => [{ type: 'SalesData', id: 'LIST' }],
        }),

        uploadSalesData: builder.mutation<TSalesDataUploadResp, FormData>({
            query: (data) => ({ url: `${PREFIX}/upload`, method: 'POST', data }),
            invalidatesTags: [{ type: 'SalesData', id: 'LIST' }],
        }),

        downloadSalesData: builder.query<any, any>({
            query: (data) => ({ url: `${PREFIX}/download`, method: 'post', data, responseType: 'arraybuffer' }),
        }),
    }),

    overrideExisting: false,
});

export const { useUploadSalesDataMutation, useGetSalesDataQuery, useLazyDownloadSalesDataQuery } = SalesDataApi;
